// NPM Imports
import React, { Component, Fragment } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { connect } from "react-redux";
import { Toastr } from "../../../revvComponents";

// Actions Imports
import PipelineActions from "../../../actions/PipelineActions";

// Internal Imports
import { GlobalUtils } from "../../../utils";
import LZLoader from "../../../commonComponents/LZLoader";

// Destructuring
const { getOpportunityById } = PipelineActions;
const { handleApiErrMsg } = GlobalUtils;

class AssetDetailsDropdown extends Component {
  state = {
    showLoader: false,
  };

  componentDidMount() {
    const { isFetch, opportunity, oppID } = this.props;
    if (isFetch) {
      if (opportunity) {
        if (opportunity.id !== oppID) {
          this._onAssetDetailsInitData(oppID);
        }
      } else {
        this._onAssetDetailsInitData(oppID);
      }
    }
  }

  _toggleLoader = flag => {
    this.setState({ showLoader: flag });
  };

  _onAssetDetailsInitData = id => {
    this.props
      .getOpportunityById(id)
      .then(() => {
        this._toggleLoader(false);
      })
      .catch(error => {
        this._toggleLoader(false);
        Toastr.showToastr({
          type: "failure",
          message: handleApiErrMsg(error),
          timeout: 3000,
        });
      });
  };

  _decideView = () => {
    const { opportunity } = this.props;
    if (this.state.showLoader) {
      return <LZLoader />;
    }
    if (opportunity) {
      const {
        name: opportunityName,
        stage_name: crmStage,
        expected_revenue: expectedRevenue,
        crm_account: { name: accountName, source: leadSource } = {},
        owner: { name: ownerName } = {},
      } = opportunity;

      return (
        <Fragment>
          <div className="assetdetailsdropdown-body">
            <div className="assetdetailsdropdown-body-row">
              <div className="assetdetailsdropdown-title-wrapper assetdetailsdropdown-firsttitle-wrapper">
                <span className="assetdetailsdropdown-metatitle">
                  <i>
                    <FontAwesomeIcon icon={["far", "briefcase"]} />
                  </i>
                  Account
                </span>
                <span className="assetdetailsdropdown-title">
                  {accountName || "-"}
                </span>
              </div>
              <div className="assetdetailsdropdown-title-wrapper">
                <span className="assetdetailsdropdown-metatitle">Owner</span>
                <span className="assetdetailsdropdown-title">
                  {ownerName || "-"}
                </span>
              </div>
              <div className="assetdetailsdropdown-title-wrapper">
                <span className="assetdetailsdropdown-metatitle">
                  Lead Source
                </span>
                <span className="assetdetailsdropdown-title">
                  {leadSource || "-"}
                </span>
              </div>
            </div>
            <div className="assetdetailsdropdown-body-row">
              <div className="assetdetailsdropdown-title-wrapper assetdetailsdropdown-firsttitle-wrapper">
                <span className="assetdetailsdropdown-metatitle">
                  <i>
                    <FontAwesomeIcon icon={["far", "crown"]} />
                  </i>
                  Opportunity
                </span>
                <span className="assetdetailsdropdown-title">
                  {opportunityName}
                </span>
              </div>
              <div className="assetdetailsdropdown-title-wrapper">
                <span className="assetdetailsdropdown-metatitle">
                  CRM Stage
                </span>
                <span className="assetdetailsdropdown-title">{crmStage}</span>
              </div>
              <div className="assetdetailsdropdown-title-wrapper">
                <span className="assetdetailsdropdown-metatitle">
                  Expected Revenue
                </span>
                <span className="assetdetailsdropdown-title">
                  ${expectedRevenue}
                </span>
              </div>
            </div>
          </div>

          <div className="assetdetailsdropdown-footer">
            <span
              onClick={this.props.showAssetDetailsModalHandler}
              onKeyPress={this.props.showAssetDetailsModalHandler}
              role="button"
              tabIndex="0">
              Click to view all details
            </span>
          </div>
        </Fragment>
      );
    }

    return null;
  };

  render() {
    return (
      <div
        className={`assetdetailsdropdown-wrapper ${this.props.positionClassName}`}
        ref={this.props.assetDetailDropdownRef}>
        {this._decideView()}
      </div>
    );
  }
}

const mapDispatchToProps = {
  getOpportunityById: id => getOpportunityById(id),
};

export default connect(null, mapDispatchToProps)(AssetDetailsDropdown);
